<template>
  <div class="tournament-list">
    <div>
      <h1 class="text-capitalize-first">{{$t('tournaments')}}</h1>
    </div>
    <div class="tabs header-content">
      <button v-for="tab in Object.values(Tabs)" :key="tab" type="button" @click="selectTab(tab)" class="btn btn-tab" :class="[state.tab === tab ? 'btn-primary' : '']"><span class="text-capitalize-first">{{ $t(`${tab}`) }}</span></button>
    </div>

    <div v-if="state.tab === Tabs.main">
      <div class="header ms-0">
        <span class="text-capitalize-first">{{$t('active')}}</span>
      </div>
      <div class="d-flex flex-column header-content gap-sm">
        <TournamentCard v-for="(item, index) in activeTournaments" :item="item" :key="item.id"  :now="state.now"></TournamentCard>
      </div>
      <div class="header ms-0">
        <span class="text-capitalize-first">{{$t('upcoming')}}</span>
      </div>
      <div class="d-flex flex-column header-content gap-sm">
        <TournamentCard v-for="(item, index) in upcomingTournaments" :item="item" :key="item.id"  :now="state.now"></TournamentCard>
      </div>
    </div>
    <div v-if="state.tab === Tabs.achievements">
      <loader-content :ref="(el: any) => loader = el">
        <div class="d-flex flex-column header-content gap-sm">
          <TournamentCard v-for="(item, index) in state.achievements.items" :item="item.tournament" :participant="item.participant" :key="item.tournament.id"  :now="state.now"></TournamentCard>
          <button @click.prevent="loadAchievements(state.achievements.offset + state.achievements.limit)" class="btn btn-outline-secondary w-100">{{$t('show_more')}}</button>
        </div>
      </loader-content>
    </div>
  </div>
</template>

<style scoped>
.tournament-list {
  display: flex;
  flex-direction: column;
  margin: 0 var(--margin-normal);
}
</style>
<script lang="ts" setup>
import {reactive} from "@vue/reactivity";
import TournamentDTO from "@/models/TournamentDTO";
import {api} from "@/service/APIClient";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import {TournamentStatus} from "@/models/enum/TournamentStatus";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TournamentAchievementDTO from "@/models/TournamentAchievementDTO";
import LoaderContent from "@/components/LoaderContent.vue";
import store from "@/store";
import {useRoute, useRouter} from "vue-router";

enum Tabs {
  main = 'main',
  achievements = 'achievements',
}

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const router = useRouter();
const route = useRoute();

const state = reactive({
  tab: (route.params.tab ? route.params.tab :  Tabs.main) as Tabs,
  achievements: {
    limit: 10,
    offset: 0,
    totalCount: 0,
    items: []
  } as PaginatedResponseDTO<TournamentAchievementDTO>,
  nowUpdateInterval: null as number|any,
  liveUpdateInterval: null as number|any,
  now: Date.now() as number
});

const activeTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item) => item.status === TournamentStatus.ACTIVE)
})

const upcomingTournaments = computed(() => {
  return store.getters.liveTournaments.filter((item) => item.status === TournamentStatus.ANNOUNCEMENT)
})

const loadAchievements = (offset: number) => {
  state.achievements.offset = offset
  loader.value?.load(async () => {
    const resp = await api.call.tournaments.achievements(state.achievements)
    if (offset === 0) {
      state.achievements = resp
    } else {
      state.achievements.items = state.achievements.items.concat(resp.items);
    }
  })
}

watch(() => loader.value, async (newValue, oldValue) => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }
  loadAchievements(0)
})

onMounted(async () => {
  await store.dispatch('setLiveTournaments', await api.call.live.tournaments());

  state.nowUpdateInterval = setInterval(() => {
    state.now = Date.now();
  }, 1000);
  state.liveUpdateInterval = setInterval(async () => {
    api.call.live.tournaments().then((resp) => store.dispatch('setLiveTournaments', resp))
  }, 10000);
});

const selectTab = (tab: Tabs) => {
  state.tab = tab
  router.replace({name: 'tournaments', params: {tab: tab}})
}

onUnmounted(() => {
  clearInterval(state.nowUpdateInterval);
  clearInterval(state.liveUpdateInterval);
});
</script>
